import React from "react";
import classnames from "classnames";
import _ from "lodash";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { Link, withRouter } from "react-router-dom";
import { Glyphicon, Navbar, NavDropdown, MenuItem } from "react-bootstrap";

import Modal from "../../../components/common/modal/Modal";
import ModalWrapper from "../../../components/common/modalWrapper/ModalWrapper";
import DeleteMemberModal from "./deleteMemberModal/DeleteMemberModal";
import Sidebar from "./sidebar/Sidebar";
import DrawerNotes from "./drawerNotes/DrawerNotes";

import { Mixpanel } from "../../../actions/mixpanel.actions";
import * as adminActions from "../../../actions/admin.actions";
import * as projectActions from "../../../actions/project.actions";
import * as authActions from "../../../actions/auth.actions";

import headers from "./headers";
import logo from "../../../assets/images/logo.svg";
import greenLogo from "../../../assets/images/logo-green.svg";
import styles from "./Header.scss";

class Header extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      pathname: this.props.location.pathname,
      header: this.getHeader(),
      showAdminDeleteMemberModal: false,
      drawerOpen: false,
      totalNotes: 0
    };

    this.getProjectTitle = this.getProjectTitle.bind(this);
    this.getCandidateName = this.getCandidateName.bind(this);
    this.getCurrentMatch = this.getCurrentMatch.bind(this);
    this.getAdminCompanyName = this.getAdminCompanyName.bind(this);

    this.pauseProject = this.pauseProject.bind(this);
    this.unpauseProject = this.unpauseProject.bind(this);
    this.cancelProject = this.cancelProject.bind(this);

    this.adminReactivateMember = this.adminReactivateMember.bind(this);
    this.adminPauseMember = this.adminPauseMember.bind(this);
    this.adminDeleteMember = this.adminDeleteMember.bind(this);
    this.adminPauseProject = this.adminPauseProject.bind(this);
    this.adminUnpauseProject = this.adminUnpauseProject.bind(this);
    this.adminCancelProject = this.adminCancelProject.bind(this);
    this.adminMoveProjectToPitched = this.adminMoveProjectToPitched.bind(this);
    this.adminCompleteProject = this.adminCompleteProject.bind(this);

    this.renderAdminProjectTitle = this.renderAdminProjectTitle.bind(this);
    this.renderAdminMemberName = this.renderAdminMemberName.bind(this);
    this.renderAdminDeleteMemberModal = this.renderAdminDeleteMemberModal.bind(
      this
    );
    this.toggleAdminDeleteMemberModal = this.toggleAdminDeleteMemberModal.bind(
      this
    );

    this.declineMember = this.declineMember.bind(this);
    this.acceptSow = this.acceptSow.bind(this);
    this.employerCompleteProject = this.employerCompleteProject.bind(this);
    this.requestEdit = this.requestEdit.bind(this);

    this.renderLogoutButton = this.renderLogoutButton.bind(this);
    this.renderBackButton = this.renderBackButton.bind(this);
    this.renderCloseButton = this.renderCloseButton.bind(this);
    this.generateH1Function = this.generateH1Function.bind(this);
    this.generateH2Function = this.generateH2Function.bind(this);
    this.generateH3Function = this.generateH3Function.bind(this);

    this.renderMemberSettings = this.renderMemberSettings.bind(this);
    this.renderCompanySettings = this.renderCompanySettings.bind(this);
    this.renderProjectSettings = this.renderProjectSettings.bind(this);
    this.renderAdminCompanies = this.renderAdminCompanies.bind(this);
    this.renderAdminMyAccount = this.renderAdminMyAccount.bind(this);
    this.adminCompanySettings = this.adminCompanySettings.bind(this);
    this.adminMemberSettings = this.adminMemberSettings.bind(this);
    this.adminProjectSettings = this.adminProjectSettings.bind(this);
    this.renderProjectCandidateSettings = this.renderProjectCandidateSettings.bind(
      this
    );

    this.redirectToAdminProjectDetail = this.redirectToAdminProjectDetail.bind(
      this
    );

    this.renderMemberFullName = this.renderMemberFullName.bind(this);

    this.onSetDrawerOpen = this.onSetDrawerOpen.bind(this);
    this.onTotalUpdate = this.onTotalUpdate.bind(this);
  }

  componentDidUpdate(prevProps, prevState) {
    const { pathname } = this.props.location;

    if (prevState.pathname !== pathname) {
      this.setState({
        pathname,
        header: this.getHeader(),
        totalNotes: 0
      });
    }
  }

  getHeader() {
    const { pathname } = this.props.location;

    const headerFinder = (headerObject, path) => {
      if (headerObject.regex) {
        return pathname.match(headerObject.expression) !== null;
      }
      return pathname.includes(path);
    };

    return _.find(headers, headerFinder) || this.getDefaultHeader();
  }

  getDefaultHeader() {
    return (
      (localStorage.getItem("role") === "admin" && headers.defaultAdmin) ||
      (localStorage.getItem("role") === "employer" && headers.defaultCompany) ||
      (localStorage.getItem("role") === "member" && headers.defaultMember) ||
      headers.default
    );
  }

  onLogout() {
    this.props.authActions.logout();
  }

  getBackgroundColor() {
    const role = localStorage.getItem("role");
    let backgroundColor = _.get(this.state, "header.backgroundColor");

    if (!backgroundColor) {
      if (role === "employer" || role === "admin") {
        backgroundColor = "blue";
      } else if (role === "member") {
        backgroundColor = "green";
      }
    }

    return backgroundColor;
  }

  render() {
    const hideInUrls = [
      "/member/sign-up-marketing",
      "/member/sign-up-marketing-2"
    ];

    const hide = hideInUrls.includes(this.props.location.pathname);
    const backgroundColor = this.getBackgroundColor();

    const headerClassName = classnames({
      [styles.header]: true,
      [styles.whiteBackground]: backgroundColor === "white",
      [styles.blueBackground]: backgroundColor === "blue",
      [styles.greenBackground]: backgroundColor === "green",
      [styles.hide]: hide === true
    });

    return (
      <div className={headerClassName}>
        <Navbar.Header className={styles.logoContainer}>
          {this.renderComponent("icon")}
          {this.renderComponent("h1")}
          {this.renderComponent("h2")}
          {this.renderComponent("h3")}
        </Navbar.Header>

        <div className={styles.desktopHeader}>
          <div>{/*this.renderComponent('center') removing this for now*/}</div>

          <div className={styles.navigationContainer}>
            <div className={styles.navigation}>
              {this.renderComponent("nav1")}
              {this.renderComponent("nav2")}
              {this.renderComponent("nav3")}
              {this.renderComponent("nav4")}
              {this.renderComponent("nav5")}
              {this.renderComponent("nav6")}
            </div>

            {this.renderComponent("button")}
          </div>
        </div>

        <Sidebar>
          {this.renderComponent("nav1")}
          {this.renderComponent("nav2")}
          {this.renderComponent("nav3")}
          {this.renderComponent("nav4")}
          {this.renderComponent("nav5")}
          {this.renderComponent("nav6")}
          {this.renderComponent("button")}
        </Sidebar>

        {this.renderAdminDeleteMemberModal()}
      </div>
    );
  }

  renderComponent(componentPosition) {
    const componentKey = this.state.header[componentPosition];

    return componentKey ? this.getComponent(componentKey) : null;
  }

  getComponent(componentKey) {
    const components = {
      adminCompanies: this.renderAdminCompanies,
      adminCompanySettings: this.adminCompanySettings,
      adminCompanyBilling: this.generateBorderedLink(
        `/admin/company/${_.get(this.props, "adminCompany.id")}/billing/add`,
        "Add Billing Activity"
      ),
      adminCompaniesTitle: this.generateH1Function(this.getAdminCompanyName()),
      adminCompaniesTitleInvoice: this.generateH1Function(
        this.getAdminCompanyNameInvoice()
      ),
      adminEditProjectTitle: this.renderAdminProjectTitle,
      adminDashboard: this.generateRenderLink("/admin/dashboard", "Dashboard"),
      adminMember: this.generateH1Function("Members"),
      adminMemberName: this.renderAdminMemberName,
      adminMemberSettings: this.adminMemberSettings,
      adminMyAccount: this.renderAdminMyAccount,
      adminProject: this.generateH1Function("Projects"),
      adminProjectSettings: this.adminProjectSettings,
      adminProjectTitle: this.renderAdminProjectTitle,
      adminProjects: this.generateRenderLink("/admin/projects", "Projects"),
      adminSettings: this.generateRenderLink("/admin/new", "Add New"),
      adminSkills: this.generateRenderLink("#", "Skills"),
      adminUsers: this.generateRenderLink("/admin/users", "Members"),
      allProjects: this.generateH1Function("All Projects"),
      back: this.renderBackButton,
      candidateName: this.generateH2Function(this.getCandidateName()),
      close: this.renderCloseButton,
      companyName: this.generateH1Function(localStorage.getItem("companyName")),
      companyProjects: this.generateRenderLink(
        "/company/projects",
        "Projects",
        "header-company-projects"
      ),
      companyInvoices: this.generateRenderLink(
        "/company/invoices",
        "Invoices",
        "header-company-invoices"
      ),
      companySettings: this.renderCompanySettings,
      completeYourRegistration: this.generateH1Function(
        "Complete Your Registration"
      ),
      createAccountBack: this.generateH1Function("Create Member Account"),
      createAccountText: this.generateRenderLink(
        "/member/sign-up",
        "New to The Second Shift? Create Account"
      ),
      createEmployerAccount: this.generateH1Function("Create Company Account"),
      currentMatch: this.generateH2Function(this.getCurrentMatch()),
      forgotPassword: this.generateH1Function("Forgot Password"),
      help: this.renderHelpButton,
      helpBordered: this.renderHelpButtonBordered,
      helpLinked: this.renderHelpLinkedButton,
      howItWorks: this.renderHowItWorks,
      invoices: this.generateH1Function("Invoices"),
      login: this.generateRenderLink("/log-in", "Login"),
      loginText: this.generateH1Function("Log In"),
      logo: this.renderLogo,
      logout: this.renderLogoutButton,
      matches: this.generateH1Function("Matches"),
      memberEmployerProfile: this.generateH1Function("Employer Profile"),
      memberProjects: this.generateRenderLink(
        "/member/projects/matches",
        "Projects",
        "header-member-projects"
      ),
      memberSettings: this.renderMemberSettings,
      memberFullName: this.renderMemberFullName,
      newProjectButton: this.renderNewProjectButton,
      projectCandidateSettings: this.renderProjectCandidateSettings,
      projectSettings: this.renderProjectSettings,
      projectTitle1: this.generateH1Function(this.getProjectTitle()),
      projectTitle2: this.generateH2Function(this.getProjectTitle()),
      step1of2: this.generateH1Function("Step 1 of 2"),
      step2of2: this.generateH1Function("Step 2 of 2"),
      submitNewProject: this.generateH1Function("Submit a New Project"),
      verifyAccount: this.generateH1Function("Verify Account")
    };

    return components[componentKey]();
  }

  renderCloseButton() {
    let closeUrl = this.state.header.closeUrl;

    if (closeUrl === "/company/projects") {
      switch (localStorage.getItem("role")) {
        case "admin":
          closeUrl = "/admin/new";
          break;
        default:
          break;
      }
    }

    if (closeUrl) {
      return (
        <Link to={closeUrl} className={styles.backButton}>
          <Glyphicon glyph="remove" className={styles.icon} />
        </Link>
      );
    } else {
      return (
        <a
          onClick={() => this.props.history.goBack()}
          className={styles.backButton}
        >
          <Glyphicon glyph="remove" className={styles.icon} />
        </a>
      );
    }
  }

  renderBackButton() {
    let backUrl = this.state.header.backUrl;

    if (backUrl === "adminProjectDetail") {
      backUrl = this.getAdminProjectDetailUrl();
    } else if (backUrl === "projectEmployer") {
      backUrl = this.getEmployerProjectDetailUrl();
    }

    if (backUrl) {
      return (
        <Link to={backUrl} className={styles.backButton}>
          <Glyphicon glyph="menu-left" className={styles.icon} />
        </Link>
      );
    } else {
      return (
        <a
          onClick={() => this.props.history.goBack()}
          className={styles.backButton}
        >
          <Glyphicon glyph="menu-left" className={styles.icon} />
        </a>
      );
    }
  }

  renderLogo() {
    const logoImg = localStorage.getItem("role") ? logo : greenLogo;

    const userRole = localStorage.getItem("role");

    const onBoarding =
      location.pathname === "/member/confirmation" ||
      location.pathname === "/member/complete-profile" ||
      location.pathname === "/member/skills" ||
      location.pathname === "/member/endorsements" ||
      location.pathname === "/company/account/settings" ||
      location.pathname === "/company/companyAffiliation" ||
      location.pathname === "/company/home" ||
      location.pathname === "/company/verify-account" ||
      location.pathname === "/company/sign-up" ||
      /^\/company\/create-company/.test(location.pathname);

    var link = "/";

    switch (userRole) {
      case "admin":
        link = "/admin/dashboard";
        break;

      case "member":
        link = "/member/projects/matches";
        break;

      case "employer":
        link = "/company/projects";
        break;
    }

    if (onBoarding) {
      return (
        <img src={logoImg} alt="The Second Shift" className={styles.logo} />
      );
    } else if (userRole) {
      return (
        <Link to={link}>
          <img src={logoImg} alt="The Second Shift" className={styles.logo} />
        </Link>
      );
    } else {
      return (
        <a href="https://www.thesecondshift.com/">
          <img src={logoImg} alt="The Second Shift" className={styles.logo} />
        </a>
      );
    }
  }

  generateH1Function(label) {
    let backUrl = this.state.header.backUrl;

    if (backUrl === "adminProjectDetail") {
      backUrl = this.getAdminProjectDetailUrl();
    } else if (backUrl === "projectEmployer") {
      backUrl = this.getEmployerProjectDetailUrl();
    }

    const linkComponent = () => (
      <Link to={backUrl} className={styles.h1}>
        {label}
      </Link>
    );

    const regularComponent = () => <div className={styles.h1}>{label}</div>;

    return backUrl ? linkComponent : regularComponent;
  }

  generateH2Function(label) {
    let backUrl = this.state.header.backUrl;

    if (backUrl === "adminProjectDetail") {
      backUrl = this.getAdminProjectDetailUrl();
    } else if (backUrl === "projectEmployer") {
      backUrl = this.getEmployerProjectDetailUrl();
    }

    const linkComponent = () => (
      <Link to={backUrl} className={styles.h2}>
        {label ? `/ ${label}` : null}
      </Link>
    );

    const regularComponent = () => (
      <div className={styles.h2}>{label ? `/ ${label}` : null}</div>
    );

    return backUrl ? linkComponent : regularComponent;
  }

  generateH3Function(label) {
    let backUrl = this.state.header.backUrl;
    if (backUrl === "adminProjectDetail") {
      backUrl = this.getAdminProjectDetailUrl();
    } else if (backUrl === "projectEmployer") {
      backUrl = this.getEmployerProjectDetailUrl();
    }

    const linkComponent = () => (
      <Link to={backUrl} className={styles.h2}>
        {label ? `/ ${label}` : null}
      </Link>
    );

    const regularComponent = () => (
      <div className={styles.h2}>{label ? `/ ${label}` : null}</div>
    );

    return backUrl ? linkComponent : regularComponent;
  }

  generateRenderLink(path, text, id = null) {
    return () => (
      <Link
        id={id}
        to={path}
        className={styles.menuButton}
        style={this.isSelected(path)}
      >
        {text}
      </Link>
    );
  }

  generateBorderedLink(path, text, id = null) {
    return () => (
      <Link
        id={id}
        to={path}
        className={classnames(styles.menuButton, styles.linkBordered)}
      >
        {text}
      </Link>
    );
  }

  getProjectTitle() {
    return _.get(this.props.project, "data.data.title");
  }

  getCandidateName() {
    const member = _.get(this.props.project, "member") || {};

    return member.first_name
      ? member.first_name + " " + member.last_name
      : null;
  }

  getCurrentMatch() {
    const project = _.get(this.props.project, "data.data");
    const companyName = _.get(project, "user.profile.company.name");

    return project && companyName ? `${project.title} at ${companyName}` : null;
  }

  getAdminCompanyName() {
    const { adminCompany } = this.props;

    const linkCompanies = <Link to={`/admin/companies`}>Companies</Link>;

    if (_.get(adminCompany, "name")) {
      const linkCompanyName = (
        <Link to={`/admin/company/${_.get(adminCompany, "id")}`}>
          {_.get(adminCompany, "name")}
        </Link>
      );

      return (
        <div>
          {linkCompanies}
          {" / "}
          {linkCompanyName}
        </div>
      );
    }

    return linkCompanies;
  }

  getAdminCompanyNameInvoice() {
    const { adminCompany } = this.props;

    const linkInvoices = <Link to={`/admin/companies/invoices`}>Invoices</Link>;

    if (_.get(adminCompany, "name")) {
      const linkCompanyName = (
        <Link to={`/admin/company/${_.get(adminCompany, "id")}/billing`}>
          {_.get(adminCompany, "name")}
        </Link>
      );

      return (
        <div>
          {linkInvoices}
          {" / "}
          {linkCompanyName}
        </div>
      );
    }

    return linkInvoices;
  }

  renderAdminMemberName() {
    const { user } = this.props.admin;

    let text = `${user.first_name} ${user.last_name}`;

    return user.first_name && this.generateH2Function(text)();
  }

  renderAdminProjectTitle() {
    const { project } = this.props.admin;

    let text = `${_.get(project, "title")} at ${_.get(
      project,
      "user.profile.company.name"
    )}`;

    if (this.state.pathname.includes("edit")) {
      text =
        text +
        (this.state.pathname.includes("sow")
          ? " / Edit SOW"
          : " / Edit Detail");
    }

    return project.title && this.generateH2Function(text)();
  }

  renderMemberFullName() {
    const firstName = _.get(this.props.pitch, "match.member.first_name");
    const lastName = _.get(this.props.pitch, "match.member.last_name");
    const fullName = firstName + " " + lastName;
    return this.generateH3Function(fullName)();
  }

  renderHowItWorks() {
    return (
      <ModalWrapper Modal={Modal}>
        <span className={styles.menuButton}>How It Works</span>
      </ModalWrapper>
    );
  }

  renderHelpButton() {
    return (
      <ModalWrapper Modal={Modal}>
        <span id="header-help" className={styles.menuButton}>
          Help
        </span>
      </ModalWrapper>
    );
  }

  renderHelpButtonBordered() {
    return (
      <a
        id="header-help"
        href="https://thesecondshift.freshdesk.com/support/home"
        target="_blank"
      >
        <span className={classnames(styles.menuButton, styles.helpBordered)}>
          Help
        </span>
      </a>
    );
  }

  renderHelpLinkedButton() {
    return (
      <a
        id="header-help"
        href="https://thesecondshift.freshdesk.com/support/home"
        target="_blank"
      >
        <span className={classnames(styles.menuButton)}>Help</span>
      </a>
    );
  }

  renderLogoutButton() {
    return (
      <span className={styles.menuButton} onClick={() => this.onLogout()}>
        Logout
      </span>
    );
  }

  renderMemberSettings() {
    const userName = localStorage.getItem("userName");

    return (
      <NavDropdown
        id="header-member-my_account"
        eventKey={3}
        title={`Hi, ${userName}`}
        className={styles.dropdownMenuButton}
        onClick={() => {
          Mixpanel.track("Header - Member - My Account - Account Menu Clicked");
        }}
      >
        <MenuItem
          id="header-member-my_account-settings"
          eventKey={3.1}
          className={styles.dropdownItem}
          onClick={() => {
            this.props.history.push("/member/account/settings");
            Mixpanel.track("Header - Member - My Account - Account Settings");
          }}
        >
          Account Settings
        </MenuItem>
        <MenuItem divider className={styles.dropdownDivider} />
        <MenuItem
          id="header-member-my_account-profile"
          eventKey={3.2}
          className={styles.dropdownItem}
          onClick={() => {
            this.props.history.push("/member/profile");
            Mixpanel.track("Header - Member - My Account - Profile");
          }}
        >
          View My Profile
        </MenuItem>
        <MenuItem divider className={styles.dropdownDivider} />
        <MenuItem
          id="header-member-my_account-logout"
          eventKey={3.3}
          className={styles.dropdownItem}
          onClick={() => {
            this.onLogout();
            Mixpanel.track("Header - Member - My Account - Log Out");
          }}
        >
          <span>Log Out</span>
        </MenuItem>
      </NavDropdown>
    );
  }

  renderNewProjectButton() {
    return (
      <Link
        id="header-company-projects-new"
        to="/company/project/create"
        className={classnames(styles.menuButton, styles.whiteButton)}
      >
        + New Project
      </Link>
    );
  }

  renderCompanySettings() {
    return (
      <NavDropdown
        id="header-company-my_account"
        eventKey={3}
        title="My Account"
        className={styles.dropdownMenuButton}
        onClick={() => {
          Mixpanel.track(
            "Header - Company - My Account - Account Menu Clicked"
          );
        }}
      >
        <MenuItem
          id="header-company-my_account-settings"
          eventKey={3.1}
          className={styles.dropdownItem}
          onClick={() => {
            this.props.history.push("/company/account/settings");
            Mixpanel.track("Header - Company - My Account - Account Settings");
          }}
        >
          Account Settings
        </MenuItem>
        <MenuItem
          id="header-company-my_account-payment-information"
          eventKey={3.2}
          className={styles.dropdownItem}
          onClick={() => {
            this.props.history.push("/company/payment/information");
            Mixpanel.track(
              "Header - Company - My Account - Payment Information"
            );
          }}
        >
          Payment Information
        </MenuItem>
        <MenuItem
          id="header-company-my_account-payment-credit-card"
          eventKey={3.2}
          className={styles.dropdownItem}
          onClick={() => {
            this.props.history.push("/company/payment");
            Mixpanel.track(
              "Header - Company - My Account - Credit Card Information"
            );
          }}
        >
          Credit Card Information
        </MenuItem>
        <MenuItem
          id="header-company-my_account-email_preferences"
          eventKey={3.2}
          className={styles.dropdownItem}
          onClick={() => {
            this.props.history.push("/account/email/preferences");
            Mixpanel.track("Header - Company - My Account - Email Preferences");
          }}
        >
          Email Preferences
        </MenuItem>
        <MenuItem
          id="header-company-my_account-logout"
          eventKey={3.3}
          className={styles.dropdownItem}
          onClick={() => {
            this.onLogout();
            Mixpanel.track("Header - Company - My Account - Log Out");
          }}
        >
          <span>Log Out</span>
        </MenuItem>
      </NavDropdown>
    );
  }

  renderProjectSettings() {
    const pauseAction = (
      <MenuItem
        eventKey={3.1}
        className={styles.dropdownItem}
        onClick={this.pauseProject}
      >
        Pause Project
      </MenuItem>
    );

    const noAvailableAction = (
      <MenuItem eventKey={3.1} className={styles.dropdownItem}>
        No Actions Available
      </MenuItem>
    );

    const unpauseAction = (
      <MenuItem
        eventKey={3.1}
        className={styles.dropdownItem}
        onClick={this.unpauseProject}
      >
        Restart Project
      </MenuItem>
    );

    const statusMap = {
      draft: [noAvailableAction],
      "submitted-for-approval": [noAvailableAction],
      approved: [pauseAction],
      matched: [pauseAction],
      rejected: [noAvailableAction],
      pitched: [pauseAction],
      "pitch-accepted": [pauseAction],
      sow: [pauseAction],
      "in-progress": [pauseAction],
      paused: [unpauseAction],
      canceled: [noAvailableAction],
      completed: [noAvailableAction],
      reviewed: [noAvailableAction]
    };

    const projectStatusName = _.get(
      this.props.project,
      "data.data.status.name"
    );

    return (
      <NavDropdown
        id="settings"
        eventKey={3}
        title="Project Options"
        noCaret
        className={classnames(styles.dropdownMenuButton, styles.bordered)}
      >
        {statusMap[projectStatusName]}
      </NavDropdown>
    );
  }

  renderProjectCandidateSettings() {
    const projectStatusName = _.get(
      this.props.project,
      "data.data.status.name"
    );
    const sow = _.get(this.props.project, "pitch.sow");
    const requestEdits = (
      <MenuItem
        eventKey={3.2}
        onClick={this.requestEdit}
        className={styles.dropdownItem}
        href="#"
      >
        Request Edits
      </MenuItem>
    );
    const acceptSow = (
      <MenuItem
        eventKey={3.3}
        onClick={this.acceptSow}
        className={styles.dropdownItem}
        href="#"
      >
        Accept SOW
      </MenuItem>
    );
    const employerCompleteProject = (
      <MenuItem
        eventKey={3.4}
        onClick={this.employerCompleteProject}
        className={styles.dropdownItem}
        href="#"
      >
        Complete Project
      </MenuItem>
    );

    const divider = <MenuItem divider className={styles.dropdownDivider} />;

    return (
      <NavDropdown
        id="settings"
        eventKey={3}
        title="Actions"
        noCaret
        className={classnames(styles.dropdownMenuButton, styles.bordered)}
      >
        <MenuItem
          eventKey={3.1}
          onClick={this.declineMember}
          className={styles.dropdownItem}
          href="#"
        >
          Decline Pitch
        </MenuItem>

        {projectStatusName === "sow" && sow && divider}
        {projectStatusName === "sow" && sow && requestEdits}
        {projectStatusName === "sow" && sow && divider}
        {projectStatusName === "sow" && sow && acceptSow}
        {projectStatusName === "in-progress" && sow && divider}
        {projectStatusName === "in-progress" && sow && employerCompleteProject}
      </NavDropdown>
    );
  }

  renderAdminCompanies() {
    return (
      <NavDropdown
        id="companies"
        eventKey={2}
        title="Companies"
        className={styles.dropdownMenuButton}
        onClick={() => {
          Mixpanel.track("Header - Admin - Companies - Menu Clicked");
        }}
      >
        <MenuItem
          id="header-admin-companies-index"
          eventKey={2.1}
          className={styles.dropdownItem}
          onClick={() => {
            this.props.history.push("/admin/companies");
            Mixpanel.track("Header - Admin - Companies - Table");
          }}
        >
          Companies
        </MenuItem>
        <MenuItem
          id="header-admin-companies-invoices"
          eventKey={2.2}
          className={styles.dropdownItem}
          onClick={() => {
            this.props.history.push("/admin/companies/invoices");
            Mixpanel.track("Header - Admin - Companies - Invoices");
          }}
        >
          Invoices
        </MenuItem>
      </NavDropdown>
    );
  }

  renderAdminMyAccount() {
    return (
      <NavDropdown
        id="settings"
        eventKey={3}
        title="My Account"
        className={classnames(styles.dropdownMenuButton, styles.leftBordered)}
        onClick={() => {
          Mixpanel.track("Header - Admin - My Account - Account Menu Clicked");
        }}
      >
        <MenuItem
          eventKey={3.3}
          className={styles.dropdownItem}
          onClick={() => {
            this.onLogout();
            Mixpanel.track("Header - Admin - My Account - Log Out");
          }}
        >
          <span>Log Out</span>
        </MenuItem>
      </NavDropdown>
    );
  }

  adminCompanySettings() {
    const totalNotes = `Admin Activity (${this.state.totalNotes})`;

    return (
      <div className={styles.flex}>
        {_.get(this.props, "adminCompany.id") && (
          <DrawerNotes
            id={_.get(this.props, "adminCompany.id")}
            type="company"
            open={this.state.drawerOpen}
            onSetOpen={this.onSetDrawerOpen}
            totalUpdate={this.onTotalUpdate}
          />
        )}
        <button
          className={classnames(styles.menuButton, styles.whiteButton)}
          onClick={() => this.onSetDrawerOpen()}
        >
          {totalNotes}
        </button>

        <Link
          to={`/admin/company/${_.get(
            this.props,
            "adminCompany.id"
          )}/billing/add`}
          className={classnames(styles.menuButton, styles.linkBordered)}
        >
          Add Billing Activity
        </Link>
      </div>
    );
  }

  adminProjectSettings() {
    const status = _.get(this.props.admin.project, "status.name");

    const isPaused = status === "paused";
    const isCanceled = status === "canceled";
    const totalNotes = `Admin Activity (${this.state.totalNotes})`;

    return (
      <div className={styles.flex}>
        {_.get(this.props.admin.project, "id") && (
          <DrawerNotes
            id={_.get(this.props.admin.project, "id")}
            type="project"
            open={this.state.drawerOpen}
            onSetOpen={this.onSetDrawerOpen}
            totalUpdate={this.onTotalUpdate}
          />
        )}
        <button
          className={classnames(styles.menuButton, styles.whiteButton)}
          onClick={() => this.onSetDrawerOpen()}
        >
          {totalNotes}
        </button>
        <NavDropdown
          id="settings"
          eventKey={3}
          title="Project Settings"
          noCaret
          className={classnames(styles.dropdownMenuButton, styles.bordered)}
        >
          {isPaused ? (
            <MenuItem
              eventKey={3.1}
              className={styles.dropdownItem}
              onClick={this.adminUnpauseProject}
            >
              Restart Project
            </MenuItem>
          ) : (
            <MenuItem
              eventKey={3.1}
              className={styles.dropdownItem}
              onClick={this.adminPauseProject}
            >
              Pause Project
            </MenuItem>
          )}
          <MenuItem divider className={styles.dropdownDivider} />
          {isCanceled ? (
            <MenuItem
              eventKey={3.2}
              className={styles.dropdownItem}
              onClick={this.adminMoveProjectToPitched}
            >
              Move to Pitched
            </MenuItem>
          ) : (
            <MenuItem
              eventKey={3.2}
              className={styles.dropdownItem}
              onClick={this.adminCancelProject}
            >
              Cancel Project
            </MenuItem>
          )}
          <MenuItem divider className={styles.dropdownDivider} />
          <MenuItem
            eventKey={3.3}
            className={styles.dropdownItem}
            onClick={this.adminCompleteProject}
          >
            Mark as Complete
          </MenuItem>
          <MenuItem divider className={styles.dropdownDivider} />
          <MenuItem
            eventKey={3.4}
            className={styles.dropdownItem}
            onClick={this.redirectToAdminProjectDetail}
          >
            Edit Project Detail
          </MenuItem>
        </NavDropdown>
      </div>
    );
  }

  adminMemberSettings() {
    const noActiveMemberAction = (
      <MenuItem
        eventKey={3.1}
        className={styles.dropdownItem}
        onClick={this.adminReactivateMember}
      >
        Re-activate Account
      </MenuItem>
    );

    const activeMemberAction = (
      <MenuItem
        eventKey={3.1}
        className={styles.dropdownItem}
        onClick={this.adminPauseMember}
      >
        Pause Account
      </MenuItem>
    );

    const deleteMemberAction = (
      <MenuItem
        eventKey={3.2}
        className={styles.dropdownItem}
        onClick={this.toggleAdminDeleteMemberModal}
      >
        Delete User
      </MenuItem>
    );

    const noAvailableAction = (
      <MenuItem eventKey={3.3} className={styles.dropdownItem}>
        No Actions Available
      </MenuItem>
    );

    const divider = <MenuItem divider className={styles.dropdownDivider} />;

    const userStatus = _.get(this.props.admin, "user.status.name");

    const totalNotes = `Admin Activity (${this.state.totalNotes})`;

    return (
      <div className={styles.flex}>
        {_.get(this.props.admin.user, "id") && (
          <DrawerNotes
            id={_.get(this.props.admin.user, "id")}
            type="user"
            open={this.state.drawerOpen}
            onSetOpen={this.onSetDrawerOpen}
            totalUpdate={this.onTotalUpdate}
          />
        )}
        <button
          className={classnames(styles.menuButton, styles.whiteButton)}
          onClick={() => this.onSetDrawerOpen()}
        >
          {totalNotes}
        </button>
        <NavDropdown
          id="settings"
          eventKey={3}
          title="Member Settings"
          noCaret
          className={classnames(styles.dropdownMenuButton, styles.bordered)}
        >
          {userStatus === "account-created" && deleteMemberAction}
          {userStatus === "applied" && deleteMemberAction}
          {userStatus === "waiting-for-references" && deleteMemberAction}
          {userStatus === "pending-interview" && deleteMemberAction}
          {userStatus === "approved" && activeMemberAction}
          {userStatus === "approved" && divider}
          {userStatus === "approved" && deleteMemberAction}
          {userStatus === "suspended" && noActiveMemberAction}
          {userStatus === "rejected" && deleteMemberAction}
          {userStatus === "blocked" && noAvailableAction}
        </NavDropdown>
      </div>
    );
  }

  renderAdminDeleteMemberModal() {
    const props = {
      onHide: this.toggleAdminDeleteMemberModal,
      deleteMember: this.adminDeleteMember
    };

    return this.state.showAdminDeleteMemberModal ? (
      <DeleteMemberModal {...props} />
    ) : null;
  }

  toggleAdminDeleteMemberModal() {
    this.setState(prevState => {
      return {
        showAdminDeleteMemberModal: !prevState.showAdminDeleteMemberModal
      };
    });
  }

  onSetDrawerOpen() {
    this.setState({ drawerOpen: !this.state.drawerOpen });
  }

  onTotalUpdate(total) {
    this.setState({ totalNotes: total });
  }

  getAdminProjectDetailUrl() {
    return `/admin/project/${_.get(this.props.admin.project, "id")}/detail`;
  }

  getEmployerProjectDetailUrl() {
    return `/company/project/${_.get(this.props.project, "data.data.id")}`;
  }

  pauseProject() {
    const payload = {
      status_id: _.find(this.props.project.status, { slug: "paused" }).id
    };

    this.props.projectActions.updateProject(
      payload,
      "/company/projects",
      this.getIdFromUrlParams()
    );
  }

  unpauseProject() {
    this.props.projectActions.unpauseProject(this.getIdFromUrlParams());
  }

  cancelProject() {
    const payload = {
      status_id: _.find(this.props.project.status, { slug: "canceled" }).id
    };

    this.props.projectActions.updateProject(
      payload,
      "/company/projects",
      this.getIdFromUrlParams()
    );
  }

  adminReactivateMember() {
    const payload = {
      user_id: this.getIdFromUrlParams(),
      status_id: _.find(this.props.user.userStatusList, { slug: "approved" }).id
    };

    this.props.adminActions.updateUser(payload);
  }

  adminPauseMember() {
    const payload = {
      user_id: this.getIdFromUrlParams(),
      status_id: _.find(this.props.user.userStatusList, { slug: "suspended" })
        .id
    };

    this.props.adminActions.updateUser(payload);
  }

  adminDeleteMember() {
    const payload = {
      user_id: this.getIdFromUrlParams(),
      status_id: _.find(this.props.user.userStatusList, { slug: "blocked" }).id
    };

    this.toggleAdminDeleteMemberModal();
    this.props.adminActions.updateUser(payload);

    this.props.history.push("/admin/users");
  }

  adminPauseProject() {
    const payload = {
      project_id: this.getIdFromUrlParams(),
      status_id: _.find(this.props.project.status, { slug: "paused" }).id
    };

    this.props.adminActions.updateProject(payload, "/admin/projects");
  }

  adminUnpauseProject() {
    this.props.adminActions.unpauseProject(this.getIdFromUrlParams());
  }

  adminCancelProject() {
    const payload = {
      project_id: this.getIdFromUrlParams(),
      status_id: _.find(this.props.project.status, { slug: "canceled" }).id
    };

    this.props.adminActions.updateProject(payload, "/admin/projects");
  }

  adminMoveProjectToPitched() {
    const payload = {
      project_id: this.getIdFromUrlParams(),
      status_id: _.find(this.props.project.status, { slug: "pitched" }).id
    };

    this.props.adminActions.updateProject(payload, "/admin/projects");
  }

  adminCompleteProject() {
    const payload = {
      project_id: this.getIdFromUrlParams(),
      status_id: _.find(this.props.project.status, { slug: "completed" }).id
    };

    this.props.adminActions.updateProject(payload, "/admin/projects");
  }

  declineMember() {
    const payload = {
      pitch_id: _.get(this.props.project, "pitch.id"),
      accept: false
    };

    this.props.projectActions.acceptPitch(payload);
  }

  acceptSow() {
    const payload = {
      sow_id: _.get(this.props.project, "pitch.sow.id"),
      accepted: true
    };

    this.props.projectActions.acceptSow(
      payload,
      _.get(this.props.project, "pitch.id")
    );
  }

  employerCompleteProject() {
    const projectId = _.get(this.props.project, "pitch.match.project_id");
    const memberId = _.get(this.props.project, "pitch.match.member_id");

    this.props.projectActions.completeProjectByEmployer(projectId, memberId);
  }

  requestEdit() {
    const payload = {
      sow_id: _.get(this.props.project, "pitch.sow.id"),
      edits_requested: true
    };

    this.props.projectActions.acceptSow(
      payload,
      _.get(this.props.project, "pitch.id")
    );
  }

  redirectToAdminProjectDetail() {
    this.props.history.push(`/admin/project/${this.getIdFromUrlParams()}/edit`);
  }

  getIdFromUrlParams(index = 0) {
    const { pathname } = this.props.location;
    const regExp = /\d+/g;

    return pathname.match(regExp)[index];
  }

  isSelected(path) {
    const isAdminSettingsPage =
      path === "/admin/new" && location.pathname.includes("/admin/new");

    return path === location.pathname ||
      /^\/member\/projects/.test(location.pathname) ||
      isAdminSettingsPage
      ? {
          borderTop: "1px solid inherit",
          borderBottom: "1px solid #FFF",
          paddingBotom: "2px",
          paddingTop: "2px"
        }
      : null;
  }
}

const mapStateToProps = state => {
  return {
    admin: state.admin,
    project: state.project,
    pitch: state.project.pitch,
    user: state.user,
    adminCompany: state.company.adminCompany
  };
};

const mapDispatchToProps = dispatch => {
  return {
    adminActions: bindActionCreators(adminActions, dispatch),
    projectActions: bindActionCreators(projectActions, dispatch),
    authActions: bindActionCreators(authActions, dispatch)
  };
};

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(Header)
);



// WEBPACK FOOTER //
// ./src/routes/common/header/Header.js